/**
 * NOTIFICATION-CENTER-UX-D1-R1 — narrowly scoped presentation helpers.
 * No HTML rendering. Not an authorization source.
 */

export const MAX_SAFE_CONTEXT_LENGTH = 280;

export function isPlainObject(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

export function safePayload(notification) {
  const payload = notification && notification.payload;
  return isPlainObject(payload) ? payload : {};
}

export function boundedText(value, maxLength = MAX_SAFE_CONTEXT_LENGTH) {
  if (typeof value !== "string") return "";
  const trimmed = value.trim();
  if (!trimmed) return "";
  if (trimmed.length <= maxLength) return trimmed;
  return `${trimmed.slice(0, Math.max(0, maxLength - 1)).trimEnd()}…`;
}

export function safeAggregateCount(payload) {
  const raw = payload && payload.count;
  const n = typeof raw === "number" ? raw : Number(raw);
  if (!Number.isFinite(n) || n <= 1) return null;
  return Math.floor(n);
}

export function formatAggregateContext(count) {
  if (!count || count <= 1) return "";
  return `Усього подій: ${count}`;
}

export function parseIsoDate(value) {
  if (typeof value !== "string" || !value.trim()) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date;
}

export function formatUkrainianDateTime(iso) {
  const date = parseIsoDate(iso);
  if (!date) return "";
  try {
    return new Intl.DateTimeFormat("uk-UA", {
      dateStyle: "medium",
      timeStyle: "short",
    }).format(date);
  } catch (_err) {
    return "";
  }
}

/**
 * Exact known producer template extraction only.
 * Does not perform general English translation.
 */
export function extractAfterExactPrefix(text, prefix) {
  const source = boundedText(text);
  if (!source || typeof prefix !== "string" || !prefix) return "";
  if (!source.startsWith(prefix)) return "";
  return boundedText(source.slice(prefix.length));
}

export function joinSupportingParts(parts) {
  return parts
    .map((part) => boundedText(part))
    .filter(Boolean)
    .join(" ");
}
